import { css } from "@emotion/react";
import React from "react";
import { useTab } from "./useTab";

export interface TabPanelProps extends React.ComponentPropsWithoutRef<"div"> {
  index?: number;
  children?: React.ReactNode;
}

/**
 * @deprecated TabUI instead
 */
export const TabPanel = ({ index = 0, children, ...props }: TabPanelProps) => {
  const { currentIndex } = useTab();
  const hidden = currentIndex !== index;
  return (
    <div
      css={
        hidden &&
        css`
          display: none;
        `
      }
      {...props}
    >
      {children}
    </div>
  );
};
